import React from 'react'
import { changeidtopress } from '../../../utilities/Convertions'
import { Flex, Flexed } from '../../../utilities/Shared'

const Synop = ({item,layout,totalsheets,mrsheets}) => {

  console.log(item)

const getplaced =(name) => {
let h = layout?.filter(filt => filt.name === name)
return h?.length
}

  return (
            <div style={{border:"2px solid #BCDDA0",fontSize:"calc(1.2rem + .2vw)",padding:"10px"}}>  
            {
              item.versions?.map(ver => {
              return  <>
             
                <Flexed>
               <Flex>{ver.name} - {ver?.width || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Width</span></>} X {ver?.length || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Length</span></>} @ {getplaced(ver.name) || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>0</span></>} up</Flex>
                </Flexed>
                </>
              })  
            }
            <div>
    
              <div style={{fontSize:"calc(1.1rem + .2vw)",padding:"3px 0px"}}>{item?.forms <= 0 ? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>0</span></> : item?.forms} form(s)&nbsp;&nbsp; - &nbsp;&nbsp;{item?.versions?.length <= 0 ? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>0</span></> : item?.versions.length} version(s)</div>     
       <div style={{fontSize:"calc(1.1rem + .2vw)",padding:"3px 0px"}} >{item.method || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Method</span></>} on {changeidtopress(item.press)} with 1 passe(s)</div>
       <div style={{fontSize:"calc(1.1rem + .2vw)",padding:"3px 0px"}} >{item.frontInks || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Front Inks</span></>} / {item.backInks || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Back Inks</span></>}</div>
       <div style={{fontSize:"calc(1.1rem + .2vw)",padding:"3px 0px"}} >{item.papername.split('-',1) || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Paper</span></>} - {item.paperid || <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Paper Id</span></>}</div>
       <div style={{fontSize:"calc(1.1rem + .2vw)"}} >({Math.ceil(parseInt(item?.needed)) || 0} sheets + {Math.ceil(parseInt(item?.addtlsheets)) || 0} additional sheets   + {item?.percentvalue}%) = 
      &nbsp; {Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)) || 0} sheets needed</div>
      
      <div style={{fontSize:"calc(1.1rem + .2vw)",marginTop:"5px"}} >{item?.mr <= 0 ? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>0 </span></> : item?.mr} sheets M/R + {Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * 1.05)} = {Math.ceil(((parseInt(item?.needed) || 0) + (parseInt(item?.addtlsheets) || 0)) * parseFloat(item?.percentover)) + parseInt(item?.mr)} sheets</div>
   
         </div> 
                 <div style={{fontSize:"calc(1.1rem + .2vw)",padding:"3px 0px"}}>{item?.pressL <= 0  ? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Sheet Length</span></> : item?.pressL} X {item?.pressW <= 0 ? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Sheet Width</span></> : item?.pressW} @ {item.parentout <= 0 || isNaN(item?.parentout)? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>0 up</span></> : <>{item.parentout} up</>} up out of a {item?.parentL <= 0 ? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Parent Length</span></> : item?.parentL} X {item?.parentW <= 0 ? <><span style={{color:"red",fontSize:"calc(1.2rem + .2vw)"}}>No Parent Width</span></> : item?.parentW} parent sheet</div>
         <div style={{fontSize:"calc(1.1rem + .2vw)"}} >{item?.needed === 0 || isNaN(item?.needed) ? <div style={{fontSize:"calc(1.1rem + .2vw)",color:"red"}}>0 sheets to order</div> : <div style={{fontSize:"calc(1.1rem + .2vw)"}}>{item?.sheetstoorder} sheets to order</div>}   </div>
    
         
   </div>
  )
}
export default Synop
// import React, { useEffect, useState, useMemo } from 'react';
// import { Piece, PieceName, SheetContainer, SheetWrap } from './EstimatesStyles';

// const Sheet = ({
//   versions,
//   totalsheetwidth,
//   totalsheetlength,
//   tail,
//   colorbar,
//   colorbarbuff,
//   gripper,
//   bleed,
//   length,
//   width,
//   setNeededsheets,
//   layout,
//   setLayout,
// }) => {
//   const [items, setItems] = useState([]);

//   const scaleup = (num) => Number(num) * 10;
//   const setnewwidth = (width) => parseFloat(width) + parseFloat(bleed) * 2;
//   const setnewlength = (length) => parseFloat(length) + parseFloat(bleed) * 2;

//   const SHEET_WIDTH = Number(totalsheetwidth) * 10;
//   const SHEET_HEIGHT = Number(totalsheetlength) * 10;

//   const getItems = () => {
//     const newItems = versions?.flatMap((item, index) =>
//       Array.from({ length: Number(item.up) || 0 }, (_, upIndex) => ({
//         id: `${index}-${upIndex}`,
//         name: item.name,
//         width: scaleup(setnewwidth(item.width)),
//         height: scaleup(setnewlength(item.length)),
//         up: Number(item.up) || 0,
//         originalwidth: item.width,
//         originallength: item.length,
//       }))
//     );
//     setItems(newItems);
//   };

//   useEffect(() => {
//     getItems();
//   }, [JSON.stringify(versions), bleed]);

//   const [newWidth, setNewWidth] = useState('');
//   const [newHeight, setNewHeight] = useState('');

//   const packPieces = (SHEET_WIDTH, SHEET_HEIGHT, pieces) => {
//     const sortedPieces = [...pieces]; // Maintain input order
//     const placed = [];
//     const unplaced = [];
//     let currentX = 0;
//     let currentY = 0;
//     let currentRowHeight = 0;

//     // First Pass: Try to place all pieces in original orientation
//     sortedPieces.forEach(piece => {
//       const originalOrientation = {
//         width: piece.width,
//         height: piece.height,
//         rotated: false,
//       };

//       // Check if the piece fits in the current row
//       if (
//         originalOrientation.width <= SHEET_WIDTH - currentX &&
//         originalOrientation.height <= SHEET_HEIGHT - currentY &&
//         originalOrientation.width <= SHEET_WIDTH &&
//         originalOrientation.height <= SHEET_HEIGHT
//       ) {
//         // Place the piece
//         placed.push({
//           ...piece,
//           x: currentX,
//           y: currentY,
//           width: originalOrientation.width,
//           height: originalOrientation.height,
//           rotated: originalOrientation.rotated,
//         });

//         // Update currentX and row height
//         currentX += originalOrientation.width;
//         currentRowHeight = Math.max(currentRowHeight, originalOrientation.height);
//       } else {
//         // Try starting a new row
//         currentY += currentRowHeight;
//         currentX = 0;
//         currentRowHeight = 0;

//         if (
//           originalOrientation.width <= SHEET_WIDTH - currentX &&
//           originalOrientation.height <= SHEET_HEIGHT - currentY &&
//           originalOrientation.width <= SHEET_WIDTH &&
//           originalOrientation.height <= SHEET_HEIGHT
//         ) {
//           placed.push({
//             ...piece,
//             x: currentX,
//             y: currentY,
//             width: originalOrientation.width,
//             height: originalOrientation.height,
//             rotated: originalOrientation.rotated,
//           });

//           currentX += originalOrientation.width;
//           currentRowHeight = originalOrientation.height;
//         } else {
//           // Cannot place in original orientation, save for second pass
//           unplaced.push(piece);
//         }
//       }
//     });

//     // Second Pass: Try to place unplaced pieces with rotation
//     unplaced.forEach(piece => {
//       const rotatedOrientation = {
//         width: piece.height,
//         height: piece.width,
//         rotated: true,
//       };

//       // Try placing in current row
//       if (
//         rotatedOrientation.width <= SHEET_WIDTH - currentX &&
//         rotatedOrientation.height <= SHEET_HEIGHT - currentY &&
//         rotatedOrientation.width <= SHEET_WIDTH &&
//         rotatedOrientation.height <= SHEET_HEIGHT
//       ) {
//         placed.push({
//           ...piece,
//           x: currentX,
//           y: currentY,
//           width: rotatedOrientation.width,
//           height: rotatedOrientation.height,
//           rotated: rotatedOrientation.rotated,
//         });

//         currentX += rotatedOrientation.width;
//         currentRowHeight = Math.max(currentRowHeight, rotatedOrientation.height);
//       } else {
//         // Try starting a new row
//         currentY += currentRowHeight;
//         currentX = 0;
//         currentRowHeight = 0;

//         if (
//           rotatedOrientation.width <= SHEET_WIDTH - currentX &&
//           rotatedOrientation.height <= SHEET_HEIGHT - currentY &&
//           rotatedOrientation.width <= SHEET_WIDTH &&
//           rotatedOrientation.height <= SHEET_HEIGHT
//         ) {
//           placed.push({
//             ...piece,
//             x: currentX,
//             y: currentY,
//             width: rotatedOrientation.width,
//             height: rotatedOrientation.height,
//             rotated: rotatedOrientation.rotated,
//           });

//           currentX += rotatedOrientation.width;
//           currentRowHeight = rotatedOrientation.height;
//         } else {
//           // Still cannot place, skip the piece
//           console.warn(`Could not place piece ${piece.id} even with rotation`);
//         }
//       }
//     });


//     return placed;
//   };

//   const placedPieces = useMemo(
//     () => packPieces(SHEET_WIDTH, SHEET_HEIGHT, items),
//     [SHEET_WIDTH, SHEET_HEIGHT, items]
//   );

//   useEffect(() => {
//     if (typeof setLayout === 'function') {
//       setLayout(placedPieces);
//     }
//   }, [placedPieces, setLayout]);

//   const pieceCounts = useMemo(() => {
//     const counts = {};
//     let totalPlaced = 0;
//     const sheetsNeededByPiece = {};
//     let maxSheetsNeeded = 0;
//     let maxPieceName = '';

//     versions?.forEach(version => {
//       counts[version.name] = {
//         expected: Number(version.up) || 0,
//         quantity: Number(version.quantity) || 0,
//         placed: 0,
//       };
//     });

//     placedPieces.forEach(piece => {
//       if (counts[piece.name]) {
//         counts[piece.name].placed += 1;
//         totalPlaced += 1;
//       }
//     });

//     Object.keys(counts).forEach(name => {
//       const placedCount = counts[name].placed;
//       const quantityNeeded = counts[name].quantity;
//       if (placedCount > 0) {
//         sheetsNeededByPiece[name] = Math.ceil(quantityNeeded / placedCount);
//       } else {
//         sheetsNeededByPiece[name] = Infinity;
//       }

//       if (sheetsNeededByPiece[name] > maxSheetsNeeded) {
//         maxSheetsNeeded = sheetsNeededByPiece[name];
//         maxPieceName = name;
//       }
//     });


//     return { counts, totalPlaced, sheetsNeededByPiece, maxSheetsNeeded, maxPieceName };
//   }, [placedPieces, versions]);

//   useEffect(() => {
//     setNeededsheets(pieceCounts?.maxSheetsNeeded);
//   }, [pieceCounts, setNeededsheets]);



//   return (
//     <div>
//       <SheetContainer>
//         <SheetWrap width={SHEET_WIDTH + 'px'} height={SHEET_HEIGHT + 'px'}>
//           {placedPieces.map(piece => (
//             <Piece
//               key={piece.id}
//               pieceId={piece.id}
//               isVisible={true}
//               height={piece.rotated ? piece.width + 'px' : piece.height + 'px'}
//               width={piece.rotated ? piece.height + 'px' : piece.width + 'px'}
//               style={{
//                 left: piece.rotated
//                   ? piece.x + (piece.width - piece.height) / 2
//                   : piece.x,
//                 top: piece.rotated
//                   ? piece.y + (piece.height - piece.width) / 2
//                   : piece.y,
//                 transform: piece.rotated ? 'rotate(90deg)' : 'none',
//                 transformOrigin: 'center center',
//                 position: 'absolute',
//                 boxSizing: 'border-box',
//                 backgroundColor: piece.rotated ? 'rgba(255, 165, 0, 0.5)' : 'rgba(0, 128, 255, 0.5)',
//                 border: '1px solid black',
//               }}
//             >
//               <PieceName>{piece.name}</PieceName>
//             </Piece>
//           ))}
//         </SheetWrap>
//       </SheetContainer>

//       <div>
//         <h3 style={{ fontSize: 'calc(1.2rem + .2vw)' }}>Piece Counts</h3>
//         <div>
//           {Object.entries(pieceCounts.counts).map(([name, { expected, placed, quantity }]) => (
//             <div key={name}>
//               <span style={{ fontSize: 'calc(1.2rem + .2vw)', fontWeight: 'bold' }}>
//                 {name}:
//               </span>
//               <span
//                 style={{
//                   fontSize: 'calc(1.2rem + .2vw)',
//                   fontWeight: 'bold',
//                   color: placed !== expected ? 'red' : 'green',
//                 }}
//               >
//                 {placed} of {expected}
//               </span>
//               <span style={{ fontSize: 'calc(1.2rem + .2vw)', marginLeft: '1rem' }}>
//                 (Sheets needed:{' '}
//                 {isFinite(pieceCounts.sheetsNeededByPiece[name])
//                   ? pieceCounts.sheetsNeededByPiece[name]
//                   : 0}
//                 )
//               </span>
//             </div>
//           ))}
//           <div>
//             <span style={{ fontSize: 'calc(1.2rem + .2vw)', fontWeight: 'bold' }}>
//               Total Pieces Placed:{' '}
//             </span>
//             <span style={{ fontSize: 'calc(1.2rem + .2vw)', fontWeight: 'bold' }}>
//               {pieceCounts.totalPlaced}
//             </span>
//           </div>
//           <div>
//             <span style={{ fontSize: 'calc(1.2rem + .2vw)', fontWeight: 'bold' }}>
//               Total Sheets Needed:{' '}
//             </span>
//             <span style={{ fontSize: 'calc(1.2rem + .2vw)', fontWeight: 'bold' }}>
//               {pieceCounts.maxSheetsNeeded !== Infinity
//                 ? pieceCounts.maxSheetsNeeded
//                 : 0}{' '}
//               (based on {pieceCounts.maxPieceName})
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Sheet;